import {isInView} from './utils'

const stickyHeader = {
  header: document.getElementById("gdHeader") as HTMLElement,
  filterDeskWrap: document.getElementById("filterDeskWrap") as HTMLElement | undefined,
  stickyProdHeader: document.getElementById("stickyProdHeader") as HTMLElement | undefined,
  prodHeader: document.getElementById("prodHeader") as HTMLElement | undefined,
  init() {
    this.setClass();
   
  },

  setClass() {
    document.addEventListener("scroll", (e) => {
      let st = window.pageYOffset || document.documentElement.scrollTop;
      const filterPosition = this.filterDeskWrap?.getBoundingClientRect().top  
   
      if(typeof filterPosition  !== 'undefined' && filterPosition < 30){
        this.header.classList.add("shrink");
      }else{
        this.header.classList.remove("shrink");
      }
      if (st === 0) {
        this.header.classList.remove("sticky");
      } else {
        this.header.classList.add("sticky");
      }
      this.setProdHeader();
    });
  },
  setProdHeader() {
    if(this.stickyProdHeader && this.prodHeader){
      if(isInView(this.prodHeader)){
        this.stickyProdHeader.classList.remove('sticky')
      }else{
        this.stickyProdHeader.classList.add('sticky')
      }
    }
  }
};

export default stickyHeader;
